import { defaultStyles as reactSelectStyles } from 'components/ReactSelect/ReactSelect';
import { infoColor } from 'assets/jss/material-dashboard-pro-react';

const tagSelectStyles = {
  ...reactSelectStyles,
  multiValue: (base, state) => ({
    ...reactSelectStyles.multiValue(base, state),
    backgroundColor: infoColor[0],
    borderRadius: '6px',
  }),
  multiValueLabel: (base, state) => ({
    ...reactSelectStyles.multiValueLabel(base, state),
    padding: '4px 8px',
    paddingLeft: '8px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '1.2',
  }),
  multiValueRemove: (base, state) => ({
    ...reactSelectStyles.multiValueRemove(base, state),
    padding: '0 8px 0 0',
  }),
};

export default tagSelectStyles;
